'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Minima = require('../../../Minima');

var _log = require('../../../utility/log');

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PluginActivator = function () {
    function PluginActivator() {
        (0, _classCallCheck3.default)(this, PluginActivator);

        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.serviceChangedListener = this.serviceChangedListener.bind(this);
    }

    /**
     * 启动插件
     * 
     * @param {PluginContext} context 插件上下文
     * @memberof PluginActivator
     */


    (0, _createClass3.default)(PluginActivator, [{
        key: 'start',
        value: function start(context) {
            _log2.default.logger.info('INFO: The plugin ' + context.plugin.id + ' is started.');
            context.addServiceChangedListener(this.serviceChangedListener);
        }

        /**
         * 服务监听
         * 
         * @param {string} name 服务名称
         * @param {ServiceAction} action 服务活动
         * @memberof PluginActivator
         */

    }, {
        key: 'serviceChangedListener',
        value: function serviceChangedListener(name, action) {
            if (action === _Minima.ServiceAction.ADDED) {
                _log2.default.logger.info('Service ' + name + ' is register.');
            } else {
                _log2.default.logger.info('Service ' + name + ' is unregister.');
            }
        }

        /**
         * 停止插件
         * 
         * @param {PluginContext} context 插件上下文
         * @memberof PluginActivator
         */

    }, {
        key: 'stop',
        value: function stop(context) {
            _log2.default.logger.info('INFO: The plugin ' + context.plugin.id + ' is stopped.');
        }
    }]);
    return PluginActivator;
}();

exports.default = PluginActivator;
//# sourceMappingURL=PluginActivator.js.map